import { MaterialStorageType } from 'api';

import { formatStorageType } from '../../utils/formatStorageType/formatStorageType';
import { SelectField, type SelectFieldProps } from '../SelectField/SelectField';

const STORAGE_TYPE_OPTIONS =
  MaterialStorageType &&
  Object.values(MaterialStorageType).map((storageType: MaterialStorageType) => ({
    label: formatStorageType(storageType),
    value: storageType,
  }));

type Props = Omit<SelectFieldProps, 'options'>;

export const StorageTypeSelectField = (props: Props) => {
  return <SelectField options={STORAGE_TYPE_OPTIONS} {...props} />;
};
